import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Calendar, MessageSquare, Activity, ClipboardCheck, BarChart3 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: FileText,
    text: 'Guía completa en español (clara, directa, sin tecnicismos)'
  }, {
    icon: Calendar,
    text: 'Plan de 7 días (paso a paso)'
  }, {
    icon: MessageSquare,
    text: 'Guiones de 60 segundos para cortar la espiral mental'
  }, {
    icon: Activity,
    text: 'Rutinas corporales de 2 a 8 minutos (sin complicarte)'
  }, {
    icon: ClipboardCheck,
    text: 'Checklist «Kit 3AM» para dejar tu mesa de noche lista'
  }, {
    icon: BarChart3,
    text: 'Plantilla de seguimiento (para ver qué capa te falla y corregir)'
  }];
  return <section className="w-full py-20 md:py-32 px-6 bg-navy-light" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-5xl font-bold text-cream mb-16 text-center" data-id="element-162">
          QUÉ RECIBES
          <span className="block text-xl md:text-2xl font-sans font-normal text-gold mt-4 tracking-wide uppercase" data-id="element-163">
            (Lo que viene en el PDF)
          </span>
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-164">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex items-center p-6 bg-navy border border-navy-lighter rounded-lg hover:border-gold/30 transition-colors" data-id="element-165">
              <div className="w-12 h-12 rounded-full bg-navy-lighter flex items-center justify-center flex-shrink-0 mr-4 text-gold" data-id="element-166">
                <item.icon className="w-6 h-6" data-id="element-167" />
              </div>
              <p className="text-lg text-cream-muted font-medium" data-id="element-168">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}